module.exports = {"330523001":"递铺街道","330523002":"昌硕街道","330523003":"灵峰街道","330523004":"孝源街道","330523103":"鄣吴镇","330523104":"杭垓镇","330523105":"孝丰镇","330523106":"报福镇","330523107":"章村镇","330523108":"天荒坪镇","330523110":"梅溪镇","330523111":"天子湖镇","330523201":"溪龙乡","330523205":"上墅乡","330523206":"山川乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330523.json
// module id = 990
// module chunks = 0